let leaving = false;

window.addEventListener("pagehide", () => {
  leaving = true;
});

window.addEventListener("pageshow", () => {
  leaving = false;
});

export const pageIsLeaving = (): boolean => leaving;
